import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaTop, WeaTab,WeaRightMenu,WeaErrorPage,WeaSearchGroup,WeaFormItem,WeaSelect,WeaAlertPage,} from 'ecCom';
import {Row,Col,Button,Form} from 'antd';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
const toJS = mobx.toJS;
import * as PublicFunc from '../util/pulic-func';
window.openFullWindowForXtable = PublicFunc.openFullWindowForXtable;
import moment from 'moment';
import {WeaTableNew,WeaSwitch} from 'comsMobx';
import {i18n} from '../public/i18n';
const WeaTable = WeaTableNew.WeaTable;
let _this;

@inject('hrmOnline')

@observer
class HrmOnline extends React.Component {
  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['onOperatesClick','jumpToHrmCard'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
    const { hrmOnline } = this.props;
    hrmOnline.getData();
  }

  render(){
    const { hrmOnline } = this.props;
    const {title,form,table,showSearchAd,searchParamsAd} = hrmOnline;

    const formParams = form.getFormParams();
    return (
      <div className='wea-myhrm-Online'>
      <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
        <WeaTop
          title={title()}
          icon={<i className='icon-coms-hrm' />}
          iconBgcolor='#217346'
          buttons={[]}
          buttonSpace={10}
          showDropIcon={false}
        >
        <WeaTab
          buttonsAd={this.getTabButtonsAd()}
          searchType={['base','advanced']}
          searchsBaseValue={formParams.lastname}
          setShowSearchAd={bool => {hrmOnline.setShowSearchAd(bool)}}
          hideSearchAd={() => hrmOnline.setShowSearchAd(false)}
          searchsAd={<Form horizontal>{this.getSearchs()}</Form>}
          showSearchAd={showSearchAd}
          onSearch={v => {hrmOnline.doSearch()}}
          onSearchChange={v => {
            form.updateFields({
                lastname:{name:'lastname',value:v},
              });
            }}
        />
        <WeaTable
          comsWeaTableStore={table}
          //hasOrder={true}
          needScroll={true}
          getColumns={c=>this.reRenderColumns(c)}
          onOperatesClick={this.onOperatesClick}
          />
        </WeaTop>
        </WeaRightMenu>
      </div>
    );
  }

  getSearchs() {
    const { hrmOnline } = this.props;
    const { form,condition } = hrmOnline;
    const {isFormInit} = form;
    let group = [];

    const formParams = form.getFormParams();
    isFormInit && !isEmpty(condition) && toJS(condition).map(c =>{
      let items = [];
      c.items.map(fields => {
        let hide = false;
        let dom = <WeaSwitch fieldConfig={fields} form={form} formParams={formParams}/>;
        items.push({
          com:(<WeaFormItem
              label={`${fields.label}`}
              labelCol={{span: `${fields.labelcol}`}}
              wrapperCol={{span: `${fields.fieldcol}`}}>
                {dom}
              </WeaFormItem>),
          colSpan:1,
          hide: hide
        })
      });
      group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
    });
    return group;
  }

  reRenderColumns(columns){
    columns.forEach(c=>{
        if(c.dataIndex=='lastname'){
            c.render = function(text, record){
                return  <span style={{cursor:'pointer'}} className='wea-hrm-linkstyle' onClick={_this.jumpToHrmCard.bind(null,record.id)}>{record.lastname}</span>
            }
        } else {
          c.render = function(text, record){
              let valueSpan = record[c.dataIndex + "span"] !== undefined ? record[c.dataIndex + "span"] : record[c.dataIndex];
              return <span dangerouslySetInnerHTML={{__html: valueSpan}}></span>
            }
        }
    })
    return columns;
  }

  onOperatesClick=(record,index,operate,flag,argumentString)=>{
    const { hrmOnline } = this.props;
    const fn = operate.href ? operate.href.split(':')[1].split('(')[0] : '';
    const id = record.id ? record.id : '';
    if(fn == 'forcedOffline'){
      hrmOnline.forcedOffline(id);
    }else{
      PublicFunc[fn](id);
    }
  }

  jumpToHrmCard(hrmId,...rest){
    PublicFunc.jumpToHrmCard(hrmId);
  }

  getRightMenu(){
    const keys = this.getSelectedRowKeys();
    const arr = [{
        icon: <i className='icon-coms-ws'/>,
        content:i18n.button.search()
      }, {
        icon: <i className='icon-coms-task-list'/>,
        content:i18n.button.columnVisibleSetting()
      }
    ];
    return arr;
  }

  onRightMenuClick(key){
    const { hrmOnline } = this.props;
    switch(key){
        case '0':
            hrmOnline.doSearch();
            break;
        case '1':
            this.definedColumn();
            break;
    }
  }

  getSelectedRowKeys(){
    const { hrmOnline } = this.props;
    const { table } = hrmOnline;
    const selectedRowKeys = table.selectedRowKeys;
    return selectedRowKeys;
  }

  definedColumn() {
    const { hrmOnline } = this.props;
    const { table} = hrmOnline;
    table.setColSetVisible(true);
    table.tableColSet(true);
  }

  getTabButtonsAd() {
    const { hrmOnline } = this.props;
    const { form,searchParamsAd } = hrmOnline;
    return [
        (<Button type="primary" onClick={()=>{hrmOnline.doSearch();hrmOnline.setShowSearchAd(false)}}>{i18n.button.search()}</Button>),
        (<Button type="ghost" onClick={()=>{form.reset();}}>{i18n.button.reset()}</Button>),
        (<Button type="ghost" onClick={()=>{hrmOnline.setShowSearchAd(false)}}>{i18n.button.cancel()}</Button>)
    ]
  }
}

export default HrmOnline



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/Online.js